import { useContext } from 'react';
import { BottomDrawerContext } from '../context/BottomDrawer/BottomDrawerProvider';

export const useBottomDrawer = () => useContext(BottomDrawerContext);